import { lazy } from "react";

const StudyPlan = lazy(() => import("@views/Student/StudyPlanV2"))
const StudyPlans = lazy(() => import("@views/Student/StudyPlans"))
const Scholarship = lazy(() => import("@views/Student/Scholarship"))
const ScoringSystem = lazy(() => import("@views/Student/ScoringSystem"))
const ScoreInformation = lazy(() => import("@views/Student/ScoreInformation"))
const StudentAttendance = lazy(() => import("@views/Student/StudentAttendance"))
const PaymentInformation = lazy(() => import("@views/Student/PaymentInformation"))
const PersonalInformation = lazy(() => import("@views/Student/PersonalInformation"))

const StudentRoutes = [
    {
        path: 'student/score-information',
        element: <ScoreInformation/>
    },
    {
        path: 'student/payment-information',
        element: <PaymentInformation/>
    },
    {
        path: 'student/offer-study-plan',
        element: <StudyPlan/>
    },
    {
        path: 'student/study-plan',
        element: <StudyPlans/>
    },
    {
        path: 'student/personal-information',
        element: <PersonalInformation/>
    },
    {
        path: 'student/scholarship',
        element: <Scholarship/>
    },
    {
        path: 'student/student-attendance',
        element: <StudentAttendance/>
    },
    {
        path: 'student/scoring-system',
        element: <ScoringSystem/>
    },
]
export default StudentRoutes
